/* eslint-disable no-unused-vars */
import { Alert, Box, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import HeaderPageDefault from "pages/admin/components/HeaderPageDefault";
import ItemCardDefault from "pages/admin/components/ItemCardDefault";
import EditModal from "./components/EditModal";
import NewModal from "./components/NewModal";
import SearchAppBar from "components/CODXSearchAppBar/SearchAppBar";
import CustomPaginationActionsTable from "components/CODXTablePagination/TablePaginationActions";
import {
  getAllTargetArea,
  newTargetArea,
  deleteTargetArea,
  patchTargetArea,
} from "api/crud/hooks/useGruposMusculares";
import TableGruposMusculares from "./components/TableGruposMusculares";
import EmptyCard from "pages/admin/components/EmptyCard";

import SimpleBackdrop from "components/SimpleBackdrop";

const PAGE_NAME = "Grupos Musculares";

const GruposMusculares = () => {
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openText, setOpenText] = useState("");
  const [openErr, setOpenErr] = useState(false);
  const [openErrText, setOpenErrText] = useState("");
  const [open, setOpen] = useState(true);
  const [busca, setBusca] = useState("");
  const [items, setItems] = useState([]);

  const handleClose = () => setOpenSuccess(false);
  const handleCloseErr = () => setOpenErr(false);

  useEffect(() => {
    GetItens();
  }, []);

  const GetItens = async () => {
    try {
      const { status, message } = await getAllTargetArea();
      setOpen(false)
      if (status === 200) {
        setItems(message);
      } else {
        setItems([]);
      }
    } catch (error) {
      setItems([]);
    }
  };

  const AddNewItem = async (payload) => {
    setOpen(true)
    try {
      const { status, message } = await newTargetArea(payload);
      setRes(status, message);
    } catch (error) {
      console.error(error);
    }
    GetItens();
  };

  const handleDeleteItem = async (id) => {
    setOpen(true)
    try {
      const { status, message } = await deleteTargetArea(id);
      setRes(status, message);
    } catch (error) {
      console.error(error);
    }
    GetItens();
  };

  const handlePatchItem = async (id, payload) => {
    setOpen(true)
    try {
      const { status, message } = await patchTargetArea(id, payload);
      setRes(status, message);
    } catch (error) {
      console.error(error);
    }
    GetItens();
  };

  const setRes = (status, message) => {
    if (status === 200) {
      setOpenText(message);
      setOpenSuccess(true);
    } else {
      setOpenErrText(message);
      setOpenErr(true);
    }
  }

  return (
    <>
      <SimpleBackdrop open={open} />
      <HeaderPageDefault addFunction={AddNewItem} tittle={PAGE_NAME} NewModal={NewModal} />
      <Box component="main" sx={{ flex: 1, py: 6, px: 4, bgcolor: "#f2f2f2" }}>
        <SearchAppBar
          value={busca}
          onChange={(caracter) => {
            setBusca(caracter);
          }}
        />
        <br />
        {items ? (
          <TableGruposMusculares
            itens={items}
            busca={busca}
            EditModal={EditModal}
            handleDeleteItem={handleDeleteItem}
            handlePatchItem={handlePatchItem}
          />
        ) : (
          <EmptyCard nome="Grupos Musculares não encontrados" />
        )}
      </Box>
      <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          {openText}
        </Alert>
      </Snackbar>
      <Snackbar open={openErr} autoHideDuration={3000} onClose={handleCloseErr}>
        <Alert onClose={handleCloseErr} severity="error" sx={{ width: "100%" }}>
          {openErrText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default GruposMusculares;
